module.exports = __webpack_public_path__ + "static/assets/b639c56f4ac6dd04b65be32de03bca1f.png";